<div class="w-full bg-white flex flex-col justify-center items-center gap-1 p-5">
	<p class="text-xl text-center">It seems like you've been signed out.</p>
	<p class="text-xl text-center"> Please log in to access your cart and continue shopping.</p>
	<a routerLink="/auth" (click)="storeUrl()"
	   class="max-w-[200px] w-full bg-[#fffcf7] hover:bg-white hover:shadow-md rounded md:rounded-md border-2 border-[#8E7862] text-[#7D5B20] py-1 px-3 hover:border-[#6c5b48]
						transition flex items-center justify-center gap-2 text-sm sm:text-base mt-4">
		<span class="">Sign In</span>
	</a>
</div>
